import React from "react";

export const FrameIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="var(--inzeloop-ds-color-action-primary-pressed)"
    >
      <path
        d="M16 1.9726V15.7808H2V1.9726H16ZM16 0H2C0.9 0 0 0.887671 0 1.9726V15.7808C0 16.8658 0.9 17.7534 2 17.7534H16C17.1 17.7534 18 16.8658 18 15.7808V1.9726C18 0.887671 17.1 0 16 0Z"
        fill="var(--inzeloop-ds-color-icon-primary)"
      />
    </svg>
  );
};
